import Vue from "vue";
import VueRouter from "vue-router";
// import store from './store';

import Home from "./views/Home";
// import About from "./views/About";
// import Accessibility from "./views/Accessibility";
// import Labs from "./views/Labs";
// import SignupPage from "./views/auth/signup.vue";
// import SigninPage from "./views/auth/signin.vue";
// import Profile from "./views/Profile";

// Added Code Splitting of routes
const About = () => import("./views/About");
const Accessibility = () => import("./views/Accessibility");
const Labs = () => import("./views/Labs");
const Signup = () => import("./views/auth/Signup");
const Signin = () => import("./views/auth/Signin");
const Profile = () => import("./views/Profile");

Vue.use(VueRouter);

export const routes = [
  {
    path: "/",
    component: Home,
    meta: {
      public: true
    }
  },
  {
    path: "/about",
    component: About,
    meta: {
      public: true
    }
  },
  {
    path: "/a11y",
    component: Accessibility,
    meta: {
      public: true
    }
  },
  {
    path: "/signup",
    component: Signup,
    meta: {
      public: true
    }
  },
  {
    path: "/signin",
    component: Signin,
    meta: {
      public: true
    }
  },
  /* NON PUBLIC ROUTES */
  {
    path: "/labs",
    component: Labs,
    meta: {
      admin: true
    }
  },
  { path: "/profile", component: Profile }
];

export default new VueRouter({ mode: "history", routes });
